import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDevPayerLink } from '@services/api';

/**
 * Dev-only: fetches dealId + token from backend and redirects to /pay/:dealId?token=...
 * Used by Dev Nav "Client / Payer" so the link works without setting env vars.
 */
export function PayDevRedirectPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getDevPayerLink()
      .then(({ data }) => {
        if (cancelled) return;
        navigate(`/pay/${data.dealId}?token=${encodeURIComponent(data.token)}`, { replace: true });
      })
      .catch((e) => {
        if (cancelled) return;
        setError((e as { message?: string })?.message ?? 'No dev payer link. Run backend_django seed first.');
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-6 font-sans bg-surface-web">
        <p className="text-surface-error-primary text-center max-w-md" role="alert">
          {error}
        </p>
        <p className="text-primary/70 text-sm mt-4 text-center max-w-md">
          In <code className="bg-surface-gray-light px-1 rounded">backend_django</code> run:{' '}
          <code className="bg-surface-gray-light px-2 py-1 rounded">python manage.py seed</code>
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 font-sans bg-surface-web">
      <p className="text-primary" aria-busy="true">
        Loading payer link…
      </p>
    </div>
  );
}
